import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import {
  Button,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  TextField
} from "@mui/material";

const EditConferenceSession = (props) => {
  const id = props.match.params.id;
  const history = useHistory();
  const eventName = localStorage.getItem("eventname");
  const eventid = localStorage.getItem("eventid");

  const [disabled, setDisabled] = useState(false);
  const [dyamicField, setDynamicField] = useState([{ c_field_name: "" }]);

  const [editConferenceCategories, setEditConferenceCategory] = useState({
    event_name: eventName,
    conference_session_category_name: "",
    error_list: [],
  });

  const [abstractHomeSetup, setAbstractHomeSetup] = useState({
    color_code_two: "#145348"
  });

  const backGroundButtonByEvent = abstractHomeSetup.color_code_two;

  // Fetch existing data
  useEffect(() => {
    axios.get(`/api/conference-session-category-eidt/${id}`).then((res) => {
      if (res.status === 200) {
        const category = res.data.data;
        setEditConferenceCategory({
          ...editConferenceCategories,
          event_name: category.event_name,
          conference_session_category_name: category.conference_session_category_name
        });

        setDynamicField(
          category.chairmen.map((value) => ({
            c_field_name: value.chairman_name
          }))
        );
      }
    });

    // Fetch theme setup
    axios.get(`/api/add-home-setup-index?id=${eventid}`).then((res) => {
      if (res.status === 200) {
        setAbstractHomeSetup(res.data.HomePageSetup);
      }
    });
  }, [id]);

  const handleInput = (e) => {
    setEditConferenceCategory({
      ...editConferenceCategories,
      [e.target.name]: e.target.value
    });
  };

  const handleDynamicInput = (e, index) => {
    const { name, value } = e.target;
    const updatedFields = [...dyamicField];
    updatedFields[index][name] = value;
    setDynamicField(updatedFields);
  };

  const handleAddDynamicField = () => {
    setDynamicField([...dyamicField, { c_field_name: "" }]);
  };

  const handleRemoveDynamicField = (index) => {
    const updatedFields = [...dyamicField];
    updatedFields.splice(index, 1);
    setDynamicField(updatedFields);
  };

  const updateConferenceCategory = (e) => {
    e.preventDefault();

    const data = {
      eventid,
      event_name: editConferenceCategories.event_name,
      conference_category_name: editConferenceCategories.conference_session_category_name,
      dyamicField
    };

    axios.get("/sanctum/csrf-cookie").then(() => {
      axios.put(`/api/conference-session-category-update/${id}`, data).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/admin/conference/list-session");
        } else {
          setEditConferenceCategory({
            ...editConferenceCategories,
            error_list: res.data.validate_error
          });
        }
      });
    });
  };

  return (
    <div style={{ margin: "1%", width: "60vw", marginLeft: "10%" }}>
      <Box sx={{ color: "#000000", marginTop: "5%" }}>
        <Button
          sx={{
            float: "right",
            marginTop: "2%",
            backgroundColor: backGroundButtonByEvent,
            ":hover": { color: "white" }
          }}
          color="success"
          size="small"
          variant="contained"
          onClick={() => history.goBack()}
        >
          Back
        </Button>

        <Card sx={{ width: "60vw" }}>
          <CardContent>
            <Typography component="h1" variant="h5">
              Edit Conference Session Category
            </Typography>

            <Box component="form" onSubmit={updateConferenceCategory} noValidate sx={{ mt: 3 }}>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <TextField
                    disabled
                    fullWidth
                    label="Event Name"
                    name="event_name"
                    value={editConferenceCategories.event_name || ""}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    required
                    fullWidth
                    label="Category Name"
                    name="conference_session_category_name"
                    value={editConferenceCategories.conference_session_category_name || ""}
                    onChange={handleInput}
                  />
                </Grid>

                {dyamicField.map((val, i) => (
                  <React.Fragment key={i}>
                    <Grid item xs={6}>
                      <TextField
                        required
                        fullWidth
                        label={`Chairman ${i + 1}`}
                        name="c_field_name"
                        value={val.c_field_name}
                        onChange={(e) => handleDynamicInput(e, i)}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      {dyamicField.length > 1 && (
                        <Button
                          onClick={() => handleRemoveDynamicField(i)}
                          variant="contained"
                          sx={{ mt: 1, backgroundColor: "#5a020b" }}
                        >
                          Remove
                        </Button>
                      )}
                      {i === dyamicField.length - 1 && (
                        <Button
                          onClick={handleAddDynamicField}
                          variant="contained"
                          sx={{ m: 1, backgroundColor: backGroundButtonByEvent }}
                        >
                          Add New Row
                        </Button>
                      )}
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>

              <Grid container justifyContent="flex-end">
                <Button
                  type="submit"
                  disabled={disabled}
                  variant="contained"
                  sx={{ mt: 5, backgroundColor: backGroundButtonByEvent }}
                >
                  Update Session Category
                </Button>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>
  );
};

export default EditConferenceSession;
